const Header = () => {
  return (
    <div className="header">
      <h2>REACT Interview Questions And Answers</h2>
    </div>
  );
};

export default Header;
